<template>
    <div id="app">
        <!--非登录视图-->
        <template v-if="hasBar == 1">
            <siderbar></siderbar>
            <div class="my-container">
                <router-view></router-view>
            </div>
        </template>
        <!--否则只需要登录界面-->
        <router-view v-else></router-view>
    </div>
</template>

<script>
    import siderbar from './components/sideBar.vue';
    export default {
        name: 'app',
        data () {
            return {
                SidebarStatus:true,
                hasBar: sessionStorage.hasBar,
            }
        },
        created(){
            this.hasBar = sessionStorage.hasBar;
        },
        watch: {
            "$route": "setHasBar",
        },
        components:{//引用组件
            siderbar:siderbar,
        },
        methods: {
            setHasBar(){
                this.hasBar = sessionStorage.hasBar;
            },
            logout(){
                this.$router.push({
                    path: '/login'
                })
            }
        }
    }
</script>

<style scoped>
    .my-container{
        height: calc(100vh);
        margin-left:170px;
        background-color: #F8F9FA;
    }
</style>
<style type="scss">
    @import "./assets/font-awesome/css/font-awesome.css";
    @media screen and (max-height:670px){.copy-right{display:none;}}
    html{
        overflow:hidden;
    }
    body{
        margin: 0;
        min-width: 1250px;
        font-family:'Microsoft YaHei';
        color: #626368;
    }
    .shenglue{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .title-bar{
        height: 60px;line-height: 60px;font-size:20px;font-weight:bold;color: #807F7F;background-color: #fff;padding:0 30px;
    }
    .main-content{
        height: calc(100vh - 106px);margin: 8px;padding: 15px 20px;background: #fff;
    }
    ::-webkit-scrollbar {/* 设置滚动条的样式 */
        width: 8px;
        height: 8px;
    }
    ::-webkit-scrollbar-thumb {/* 滚动条滑块 */
        border-radius: 6px;
        background: rgba(0,0,0,0.1);
    }
    .clear{
        clear: both;
    }
    .searchObj .el-range-editor.el-input__inner{
        width: 260px;
    }
    .searchObj .el-date-editor .el-range-separator{
        width: 8% !important;
    }
    /*.el-button--primary {*/
    /*    color: #FFF;*/
    /*    background-color: #409EFF!important;*/
    /*    border-color: #409EFF!important;*/
    /*}*/
    /*.el-button--primary.is-plain {*/
    /*    color: #409EFF!important;*/
    /*    background: #ecf5ff!important;*/
    /*    border-color: #409EFF!important;*/
    /*}*/
    .el-dialog__body {
        padding: 10px 20px 0 20px!important;
    }
    .el-dialog__footer {
        padding: 0 20px 20px!important;
    }
    .el-notification__content {
        margin-top: 1px!important;
    }
    /*.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {*/
    /*    background-color: #409EFF!important;*/
    /*    border-color: #409EFF!important;*/
    /*}*/
    /*.el-checkbox__inner:hover {*/
    /*    border-color: #409EFF!important;*/
    /*}*/
    .tab-click{
        margin-right: 10px;
    }
    .tab-click:last-child{
        margin-right: 0;
    }
    .tab-click:hover{
        text-decoration: underline;
        color: #409EFF;
        cursor: pointer;
    }
    .el-tabs__nav-wrap::after{
        background-color: transparent!important;
    }
    .form-det .el-input.is-disabled .el-input__inner{
        color: #0f0f0f;
    }
    .form-det .el-textarea.is-disabled .el-textarea__inner{
        color: #0f0f0f;
    }
    textarea{
        font-family:'Microsoft YaHei';
    }
</style>
